"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThorgateRebalanced = void 0;
var Card_1 = require("../../Card");
var Tags_1 = require("../../Tags");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var CardType_1 = require("../../CardType");
var CardRenderer_1 = require("../../render/CardRenderer");
var Size_1 = require("../../render/Size");
var ThorgateRebalanced = (function (_super) {
    __extends(ThorgateRebalanced, _super);
    function ThorgateRebalanced() {
        return _super.call(this, {
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.THORGATE_REBALANCED,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.ENERGY],
            startingMegaCredits: 40,
            cardDiscount: { tag: Tags_1.Tags.ENERGY, amount: 3 },
            metadata: {
                cardNumber: 'R13',
                description: 'You start with 1 energy production and 40 M€.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.energy(1); }).nbsp.megacredits(40);
                    b.corpBox('action', function (ce) {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.action('Decr. energy prod. gain 6 M€.', function (eb) {
                            eb.production(function (pb) { return pb.energy(1); }).startAction.megacredits(6);
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.effect('When playing a power card OR SP POWER OR TURMOIL KELVINISTS ACTION, you pay 3 M€ less for it.', function (eb) {
                            eb.energy(1).played.asterix().slash().production(function (pb) {
                                pb.energy(1).heat(1);
                            }).asterix().startEffect.megacredits(-3);
                        });
                    });
                }),
            },
        }) || this;
    }
    ThorgateRebalanced.prototype.getCardDiscount = function (_player, card) {
        if (card.tags.includes(Tags_1.Tags.ENERGY)) {
            return 3;
        }
        return 0;
    };
    ThorgateRebalanced.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, 1);
        return undefined;
    };
    ThorgateRebalanced.prototype.canAct = function (player) {
        return player.getProduction(Resources_1.Resources.ENERGY) >= 1;
    };
    ThorgateRebalanced.prototype.action = function (player) {
        if (player.getProduction(Resources_1.Resources.ENERGY) >= 1) {
            return this.getMegacreditsOption(player);
        }
        return undefined;
    };
    ThorgateRebalanced.prototype.getMegacreditsOption = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, -1);
        player.addResource(Resources_1.Resources.MEGACREDITS, 6);
        player.game.log('${0} decreased energy production 1 step to gain 6 M€', function (b) { return b.player(player); });
        return undefined;
    };
    return ThorgateRebalanced;
}(Card_1.Card));
exports.ThorgateRebalanced = ThorgateRebalanced;
//# sourceMappingURL=ThorgateRebalanced.js.map